<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t('profile.label.bo_investment_purpose')"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <div class="col-md-6 offset-md-3">
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input" type="checkbox"
                   id="boPurposeShortTermFlg"
                   v-model="$v.input['amsCustomerDetail.boInvestmentPurposeView'].boPurposeShortTermFlg.$model"
                   true-value="1"
                   false-value="0"
                   @change="handleForceNewEvent"
            >
            <label class="form-check-label" for="boPurposeShortTermFlg">
              {{ $t('profile.bo_investment_purpose.bo_purpose_short_term_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                id="boPurposeDispAssetMngFlg"
                v-model="$v.input['amsCustomerDetail.boInvestmentPurposeView'].boPurposeDispAssetMngFlg.$model"
                true-value="1"
                false-value="0"
                @change="handleForceNewEvent"
            >
            <label class="form-check-label" for="boPurposeDispAssetMngFlg">
              {{ $t('profile.bo_investment_purpose.bo_purpose_disp_asset_mng_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                id="boPurposeHedgeFlg"
                v-model="$v.input['amsCustomerDetail.boInvestmentPurposeView'].boPurposeHedgeFlg.$model"
                true-value="1"
                false-value="0"
                @change="handleForceNewEvent"
            >
            <label class="form-check-label" for="boPurposeHedgeFlg">
              {{ $t('profile.bo_investment_purpose.bo_purpose_hedge_flg') }}
            </label>
          </div>
        </div>
        <div class=" error-messages ng-active"
             v-if="$v.input['amsCustomerDetail.boInvestmentPurposeView'].$error ||$v.input['amsCustomerDetail.boInvestmentPurposeView'].$anyError ">
          <div class="form-check">
            {{ $t('MSG_TRS_NAF_0004_BO', {param1: $t('profile.label.bo_investment_purpose')}) }}
          </div>
        </div>
        <div class="toggle-div-ct"
             v-show="input['amsCustomerDetail.boInvestmentPurposeView'].boPurposeHedgeFlg == '1'">
          <div class="row">
            <div class="col-md-4">
              <select class="form-control"
                      v-model="$v.input['amsCustomerDetail.boPurposeHedgeType'].$model"
                      required
                      name="boPurposeHedgeType">
                <option v-for="item in listBoPurposeHedgeType" :key="item.key" :value="item.key">
                  {{ $t(item.value) }}
                </option>
              </select>
              <div
                  v-if="$v.input['amsCustomerDetail.boPurposeHedgeType'].$dirty && $v.input['amsCustomerDetail.boPurposeHedgeType'].$error"
                  class="error-messages ng-active">
                <div v-if="!$v.input['amsCustomerDetail.boPurposeHedgeType'].required">
                  {{ $t('MSG_TRS_NAF_0004_BO', {param1: $t('profile.label.bo_investment_purpose')}) }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <select class="form-control"
                      v-model="$v.input['amsCustomerDetail.boPurposeHedgeAmount'].$model"
                      required
                      name="boPurposeHedgeAmount">
                <option v-for="item in listFinalAssetsWithHeader" :key="item.key" :value="item.key">
                  {{ $t(item.value) }}
                </option>
              </select>
              <div
                  v-if="$v.input['amsCustomerDetail.boPurposeHedgeAmount'].$dirty && $v.input['amsCustomerDetail.boPurposeHedgeAmount'].$error"
                  class="error-messages ng-active">
                <div v-if="!$v.input['amsCustomerDetail.boPurposeHedgeAmount'].required">
                  {{ $t('MSG_TRS_NAF_0004_BO', {param1: $t('profile.label.bo_investment_purpose')}) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit"
                :type="this.getButtonType()">
          {{ $t('profile.button.submit') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click="reverseInput">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {required} from 'vuelidate/lib/validators';
import {parentCheckboxRequiredValidation} from '@/common/helpers/validation'

export default {
  name: "UpdateBoInvestPurpose",
  props: {},
  data() {
    return {}
  },
  mixins: [formMixin, forceNewUtil],
  methods: {
  },
  validations() {
    return {
      input: {
        'amsCustomerDetail.boInvestmentPurposeView': {
          boPurposeShortTermFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.boInvestmentPurposeView'])
          },
          boPurposeDispAssetMngFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.boInvestmentPurposeView'])
          },
          boPurposeHedgeFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.boInvestmentPurposeView'])
          }
        },
        'amsCustomerDetail.boPurposeHedgeType': {
          required
        },
        'amsCustomerDetail.boPurposeHedgeAmount': {
          required
        }
      }
    }
  },
  computed: {
    listFinalAssetsWithHeader() {
      return this.input.listFinalAssetsWithHeader
    },
    listBoPurposeHedgeType() {
      return this.IConstants.listBoPurposeHedgeType;
    }
  },
}
</script>

<style scoped>
</style>
